var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 232.14 174.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      strokeOpacity: 0,
      fill: "#fff"
    },
    d: "M0 .254h231.91v174.54H0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      strokeWidth: 0,
      fill: "#c00"
    },
    d: "M0 106.18h340.16v42.52H0z",
    transform: "matrix(.68243 0 0 .69076 .006 -1.36)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      strokeWidth: 0,
      fill: "#c00"
    },
    d: "M148.82 1.968h42.52v253.03h-42.52z",
    transform: "matrix(.68243 0 0 .69076 .006 -1.36)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#c00"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.73 13.251c7.187 14.704 8.8 30.18 0 44.057h20.08c-7.23-17.953-6.403-30.179 0-44.057H40.73z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.034 45.456c14.527-7.275 29.815-8.906 43.526 0V25.131c-17.737 7.319-29.815 6.481-43.526 0v20.325z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#c00"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.73 116.047c7.187 14.704 8.8 30.18 0 44.057h20.08c-7.23-17.953-6.403-30.179 0-44.057H40.73z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.034 148.252c14.527-7.275 29.815-8.906 43.526 0v-20.325c-17.737 7.319-29.815 6.481-43.526 0v20.325z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#c00"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M171.303 116.047c7.186 14.704 8.798 30.18 0 44.057h20.08c-7.231-17.953-6.404-30.179 0-44.057h-20.08z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M159.606 148.252c14.527-7.275 29.815-8.906 43.526 0v-20.325c-17.737 7.319-29.815 6.481-43.526 0v20.325z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#c00"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M171.303 13.251c7.186 14.704 8.798 30.18 0 44.057h20.08c-7.231-17.953-6.404-30.179 0-44.057h-20.08z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M159.606 45.456c14.527-7.275 29.815-8.906 43.526 0V25.131c-17.737 7.319-29.815 6.481-43.526 0v20.325z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKa);
export default __webpack_public_path__ + "static/media/ka.2cba5562f1f2150b2cbb501a56682357.svg";
export { ForwardRef as ReactComponent };